import * as highlight from './snbt-highlighter.gen';
import * as parser from './snbt-parser.gen';
export { IntegerValue, FloatValue, IntegerList, createInteger, createFloat, } from './snbt-parser.base';
export const parse = parser.parse;
export const highlights = (input, options) => {
    const tokens = highlight.parse(input, options);
    const occupiedRange = [];
    return tokens
        .reverse()
        .filter(token => {
        if (occupiedRange.some(range => token.start <= range[1] - 1 && range[0] <= token.end - 1)) {
            return false;
        }
        occupiedRange.push([token.start, token.end]);
        return true;
    })
        .reverse();
};
//# sourceMappingURL=index.js.map